module.exports = __webpack_public_path__ + "static/media/EC Photo 4.d3f71c7c.jpg";